import { ErrorPage } from './ErrorPage';

export interface Error404PageProps {}

export const Error404Page = (props: Error404PageProps) => {
  return <ErrorPage contentCode="ERROR_404_CONTENT" errorCode={404} />;
};
